import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * The `Date` scalar type represents a date. The Date appears in a JSON
	 * response as an ISO8601 formatted string, without a time component.
	 */
	Date: { input: string; output: string };
	/**
	 * The `DateTime` scalar type represents a date and time in the UTC
	 * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
	 * string, including UTC timezone ("Z"). The parsed date and time string will
	 * be converted to UTC if there is an offset.
	 */
	DateTime: { input: string; output: string };
	/**
	 * The `Decimal` scalar type represents signed double-precision fractional
	 * values parsed by the `Decimal` library. The Decimal appears in a JSON
	 * response as a string to preserve precision.
	 */
	Decimal: { input: string; output: string };
	/**
	 * The `Money` scalar type represents a monetary value with a currency. The value
	 * is represented as a string in the format `"100.00 MXN"` or `"MXN 100.00"`.
	 */
	Money: { input: string; output: string };
	/**
	 * The `UUID7` scalar type represents UUID7 compliant string data, represented as UTF-8
	 * character sequences.
	 */
	UUID7: { input: string; output: string };
};

/** The action failed due to an unexpected reason. */
export type ActionFailed = {
	__typename?: 'ActionFailed';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

export type ActivityOrBusinessInformation = {
	__typename?: 'ActivityOrBusinessInformation';
	activityDetail?: Maybe<Scalars['String']['output']>;
	activityType?: Maybe<Scalars['String']['output']>;
	operatingTimeRange?: Maybe<OperatingTimeRanges>;
	startDate?: Maybe<Scalars['Date']['output']>;
};

export enum ApplicantNetIncomeIndex {
	HALF_OR_LESS_THAN_ONE_POINT = 'HALF_OR_LESS_THAN_ONE_POINT',
	LESS_THAN_HALF_POINT = 'LESS_THAN_HALF_POINT',
	ONE_OR_LESS_THAN_TWO_POINTS = 'ONE_OR_LESS_THAN_TWO_POINTS',
	TWO_OR_MORE_POINTS = 'TWO_OR_MORE_POINTS'
}

export enum ApplicantPaymentExperienceI {
	NO_DATA = 'NO_DATA',
	NO_DELAY = 'NO_DELAY',
	ONE_MONTH = 'ONE_MONTH',
	SIX_MONTHS = 'SIX_MONTHS'
}

export enum ApplicantPaymentExperienceIi {
	NINETY_ONE_DAYS = 'NINETY_ONE_DAYS',
	ONE_DAY = 'ONE_DAY',
	SIXTY_ONE_DAYS = 'SIXTY_ONE_DAYS',
	THIRTY_ONE_DAYS = 'THIRTY_ONE_DAYS'
}

export type ApproveRequestByCreditCommitteeInput = {
	committeeDeliberation: Scalars['String']['input'];
	committeeRequestedChanges: Scalars['String']['input'];
	microcreditRequestId: Scalars['UUID7']['input'];
};

export type ApproveRequestByCreditCommitteePayload = {
	__typename?: 'ApproveRequestByCreditCommitteePayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export enum CommitteeRuling {
	APPROVED_BY_COMMITTEE = 'APPROVED_BY_COMMITTEE',
	REJECTED_BY_COMMITTEE = 'REJECTED_BY_COMMITTEE'
}

export type CreditBureauReport = {
	__typename?: 'CreditBureauReport';
	creditBureauScore?: Maybe<Scalars['Int']['output']>;
	firstCreditDate?: Maybe<Scalars['Date']['output']>;
	oldestDuePayment?: Maybe<OldestDuePayment>;
	reportDate?: Maybe<Scalars['Date']['output']>;
	totalActiveCreditBalance?: Maybe<Scalars['Money']['output']>;
	totalActiveNumberOfCredits?: Maybe<Scalars['Int']['output']>;
	totalCreditBalance?: Maybe<Scalars['Money']['output']>;
	totalNumberOfCredits?: Maybe<Scalars['Int']['output']>;
};

export type CreditDetails = {
	__typename?: 'CreditDetails';
	amountRequested?: Maybe<Scalars['Money']['output']>;
	creditUse?: Maybe<Scalars['String']['output']>;
	creditUseDetail?: Maybe<Scalars['String']['output']>;
	expectedAdditionalIncome?: Maybe<Scalars['Money']['output']>;
};

export type DatetimeRange = {
	from?: InputMaybe<Scalars['DateTime']['input']>;
	to?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DaysPerSimulationPeriod {
	BIWEEKLY = 'BIWEEKLY',
	MONTHLY = 'MONTHLY',
	WEEKLY = 'WEEKLY'
}

export enum EconomicSolvencyIi {
	BETWEEN_ONE_POINT = 'BETWEEN_ONE_POINT',
	EQUAL_TWO_POINTS = 'EQUAL_TWO_POINTS',
	LESS_ONE_POINT = 'LESS_ONE_POINT',
	MORE_TWO_POINTS = 'MORE_TWO_POINTS'
}

export type EvaluationMatrix = {
	__typename?: 'EvaluationMatrix';
	applicantNetIncomeIndex?: Maybe<ApplicantNetIncomeIndex>;
	applicantPaymentExperienceI?: Maybe<ApplicantPaymentExperienceI>;
	applicantPaymentExperienceIi?: Maybe<ApplicantPaymentExperienceIi>;
	economicSolvencyIi?: Maybe<EconomicSolvencyIi>;
	familyMemberPaymentExperienceIi?: Maybe<FamilyMemberPaymentExperienceIi>;
	totalScore?: Maybe<Scalars['Int']['output']>;
};

export enum FamilyMemberPaymentExperienceIi {
	NINETY_ONE_DAYS = 'NINETY_ONE_DAYS',
	ONE_DAY = 'ONE_DAY',
	SIXTY_ONE_DAYS = 'SIXTY_ONE_DAYS',
	THIRTY_ONE_DAYS = 'THIRTY_ONE_DAYS'
}

export type FillEvaluationMatrixInput = {
	applicantNetIncomeIndex: ApplicantNetIncomeIndex;
	applicantPaymentExperienceI: ApplicantPaymentExperienceI;
	applicantPaymentExperienceIi: ApplicantPaymentExperienceIi;
	economicSolvencyIi: EconomicSolvencyIi;
	familyMemberPaymentExperienceIi: FamilyMemberPaymentExperienceIi;
	microcreditRequestId: Scalars['UUID7']['input'];
};

export type FillEvaluationMatrixPayload = {
	__typename?: 'FillEvaluationMatrixPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export enum HouseType {
	FAMILY = 'FAMILY',
	MORTGAGED = 'MORTGAGED',
	OWNED = 'OWNED',
	RENTED = 'RENTED'
}

/** The action was not allowed for a given reason. */
export type InvalidAction = {
	__typename?: 'InvalidAction';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Provided input is not valid. */
export type InvalidInput = {
	__typename?: 'InvalidInput';
	/** Validation context. */
	context: Array<Maybe<InvalidInputContext>>;
	/** Invalid input field's name. */
	field: Scalars['String']['output'];
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Parameter taken into consideration for the validation. */
export type InvalidInputContext = {
	__typename?: 'InvalidInputContext';
	key: Scalars['String']['output'];
	value?: Maybe<Scalars['String']['output']>;
};

/** Microcredit Request */
export type MicrocreditRequest = Node & {
	__typename?: 'MicrocreditRequest';
	activityOrBusinessInformation?: Maybe<ActivityOrBusinessInformation>;
	applicantComprehensiveOperativeEfficiency?: Maybe<Scalars['Decimal']['output']>;
	businessComprehensiveOperativeEfficiency?: Maybe<Scalars['Decimal']['output']>;
	calculatedNetIncome?: Maybe<Scalars['Money']['output']>;
	calculatedNetIncomeIndex?: Maybe<Scalars['Decimal']['output']>;
	callComments?: Maybe<Scalars['String']['output']>;
	clientId?: Maybe<Scalars['ID']['output']>;
	committeeDeliberation?: Maybe<Scalars['String']['output']>;
	committeeRequestedChanges?: Maybe<Scalars['String']['output']>;
	committeeRuling?: Maybe<CommitteeRuling>;
	creditAreaOpinion?: Maybe<Scalars['String']['output']>;
	creditBureauReport?: Maybe<CreditBureauReport>;
	creditDetails?: Maybe<CreditDetails>;
	economicSolvencyIi?: Maybe<Scalars['Decimal']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	evaluationMatrix?: Maybe<EvaluationMatrix>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	/** The ID of an object */
	id: Scalars['ID']['output'];
	microcreditRequestId?: Maybe<Scalars['ID']['output']>;
	microcreditRequestStatus?: Maybe<MicrocreditRequestStatus>;
	monthlyBusinessExpenses?: Maybe<MonthlyBusinessExpenses>;
	monthlyHouseExpenses?: Maybe<MonthlyHouseExpenses>;
	monthlyIncomeInformation?: Maybe<MonthlyIncomeInformation>;
	names?: Maybe<Scalars['String']['output']>;
	onboardingRegistryDeliberation?: Maybe<Scalars['String']['output']>;
	onboardingStatus?: Maybe<OnboardingStatus>;
	otherCredits?: Maybe<OtherCredits>;
	personalInformation?: Maybe<PersonalInformation>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
	recoveryTimeInYears?: Maybe<Scalars['Decimal']['output']>;
	rejectionReason?: Maybe<Scalars['String']['output']>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	simulation?: Maybe<Simulation>;
	startedAt?: Maybe<Scalars['DateTime']['output']>;
	valueOfAssets?: Maybe<ValueOfAssets>;
};

export type MicrocreditRequestConnection = {
	__typename?: 'MicrocreditRequestConnection';
	count?: Maybe<Scalars['Int']['output']>;
	edges?: Maybe<Array<Maybe<MicrocreditRequestEdge>>>;
	pageInfo: PageInfo;
};

export type MicrocreditRequestConnectionCountArgs = {
	filter?: InputMaybe<MicrocreditRequestFilter>;
};

export type MicrocreditRequestEdge = {
	__typename?: 'MicrocreditRequestEdge';
	cursor?: Maybe<Scalars['String']['output']>;
	node?: Maybe<MicrocreditRequest>;
};

export type MicrocreditRequestFilter = {
	microcreditRequestStatus?: InputMaybe<Array<InputMaybe<MicrocreditRequestStatus>>>;
	onboardingStatus?: InputMaybe<Array<InputMaybe<OnboardingStatus>>>;
	searchTerm?: InputMaybe<Scalars['String']['input']>;
	startedAt?: InputMaybe<DatetimeRange>;
};

export type MicrocreditRequestSort = {
	microcreditRequestStatus?: InputMaybe<SortDirection>;
	startedAt?: InputMaybe<SortDirection>;
};

export enum MicrocreditRequestStatus {
	ACTIVITY_INFORMATION_REGISTERED = 'ACTIVITY_INFORMATION_REGISTERED',
	APPROVED_BY_CREDIT_COMMITTEE = 'APPROVED_BY_CREDIT_COMMITTEE',
	COMPLETED = 'COMPLETED',
	CREATED = 'CREATED',
	CREDIT_DETAILS_REGISTERED = 'CREDIT_DETAILS_REGISTERED',
	IN_REVIEW = 'IN_REVIEW',
	MONTHLY_BUSINESS_EXPENSES_REGISTERED = 'MONTHLY_BUSINESS_EXPENSES_REGISTERED',
	MONTHLY_HOUSE_EXPENSES_REGISTERED = 'MONTHLY_HOUSE_EXPENSES_REGISTERED',
	MONTHLY_INCOME_INFORMATION_REGISTERED = 'MONTHLY_INCOME_INFORMATION_REGISTERED',
	OTHER_CREDITS_REGISTERED = 'OTHER_CREDITS_REGISTERED',
	PASSED_TO_CREDIT_COMMITTEE = 'PASSED_TO_CREDIT_COMMITTEE',
	PERSONAL_INFORMATION_REGISTERED = 'PERSONAL_INFORMATION_REGISTERED',
	REJECTED = 'REJECTED',
	REJECTED_BY_CREDIT_COMMITTEE = 'REJECTED_BY_CREDIT_COMMITTEE',
	VALUE_OF_ASSETS_REGISTERED = 'VALUE_OF_ASSETS_REGISTERED'
}

export type MonthlyBusinessExpenses = {
	__typename?: 'MonthlyBusinessExpenses';
	electricBill?: Maybe<Scalars['Money']['output']>;
	equipmentMaintenance?: Maybe<Scalars['Money']['output']>;
	gas?: Maybe<Scalars['Money']['output']>;
	inputsPurchase?: Maybe<Scalars['Money']['output']>;
	internetBill?: Maybe<Scalars['Money']['output']>;
	rent?: Maybe<Scalars['Money']['output']>;
	salaries?: Maybe<Scalars['Money']['output']>;
	totalBusinessExpenses?: Maybe<Scalars['Money']['output']>;
};

export type MonthlyHouseExpenses = {
	__typename?: 'MonthlyHouseExpenses';
	electricBill?: Maybe<Scalars['Money']['output']>;
	familyExpenses?: Maybe<Scalars['Money']['output']>;
	groceries?: Maybe<Scalars['Money']['output']>;
	internetBill?: Maybe<Scalars['Money']['output']>;
	rent?: Maybe<Scalars['Money']['output']>;
	totalHouseExpenses?: Maybe<Scalars['Money']['output']>;
	tuitions?: Maybe<Scalars['Money']['output']>;
	waterBill?: Maybe<Scalars['Money']['output']>;
};

export type MonthlyIncomeInformation = {
	__typename?: 'MonthlyIncomeInformation';
	businessSales?: Maybe<Scalars['Money']['output']>;
	familyContributionsIncome?: Maybe<Scalars['Money']['output']>;
	otherSourcesIncome?: Maybe<Scalars['Money']['output']>;
	otherSourcesIncomeDetail?: Maybe<Scalars['String']['output']>;
	salary?: Maybe<Scalars['Money']['output']>;
	totalIncome?: Maybe<Scalars['Money']['output']>;
};

/** Common errors for any mutation. */
export type MutationError = ActionFailed | InvalidAction | InvalidInput;

export type Node = {
	/** The ID of the object. */
	id: Scalars['ID']['output'];
};

export enum OldestDuePayment {
	CODE_00 = 'CODE_00',
	CODE_01 = 'CODE_01',
	CODE_02 = 'CODE_02',
	CODE_03 = 'CODE_03',
	CODE_04 = 'CODE_04',
	CODE_05 = 'CODE_05',
	CODE_06 = 'CODE_06',
	CODE_07 = 'CODE_07',
	CODE_96 = 'CODE_96',
	CODE_97 = 'CODE_97',
	CODE_99 = 'CODE_99',
	CODE_UR = 'CODE_UR'
}

export enum OnboardingStatus {
	APPROVED = 'APPROVED',
	CORRECTIONS_REQUESTED = 'CORRECTIONS_REQUESTED',
	IN_PROCESS = 'IN_PROCESS',
	PENDING_REVIEW = 'PENDING_REVIEW',
	REJECTED = 'REJECTED'
}

export enum OperatingTimeRanges {
	BETWEEN_SIXTH_AND_TENTH_YEAR = 'BETWEEN_SIXTH_AND_TENTH_YEAR',
	IN_FIFTH_YEAR = 'IN_FIFTH_YEAR',
	IN_FIRST_YEAR = 'IN_FIRST_YEAR',
	IN_FOURTH_YEAR = 'IN_FOURTH_YEAR',
	IN_SECOND_YEAR = 'IN_SECOND_YEAR',
	IN_THIRD_YEAR = 'IN_THIRD_YEAR',
	MORE_THAN_TEN_YEARS = 'MORE_THAN_TEN_YEARS'
}

export type OtherCredits = {
	__typename?: 'OtherCredits';
	currentTotalDebt?: Maybe<Scalars['Money']['output']>;
	monthlyPaymentToCredits?: Maybe<Scalars['Money']['output']>;
};

export type PageInfo = {
	__typename?: 'PageInfo';
	/** When paginating forwards, the cursor to continue. */
	endCursor?: Maybe<Scalars['String']['output']>;
	/** When paginating forwards, are there more items? */
	hasNextPage: Scalars['Boolean']['output'];
	/** When paginating backwards, are there more items? */
	hasPreviousPage: Scalars['Boolean']['output'];
	/** When paginating backwards, the cursor to continue. */
	startCursor?: Maybe<Scalars['String']['output']>;
};

export type PassRequestToCreditCommitteeInput = {
	creditAreaOpinion: Scalars['String']['input'];
	microcreditRequestId: Scalars['UUID7']['input'];
};

export type PassRequestToCreditCommitteePayload = {
	__typename?: 'PassRequestToCreditCommitteePayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type PersonalInformation = {
	__typename?: 'PersonalInformation';
	childDependants?: Maybe<Scalars['Int']['output']>;
	houseType?: Maybe<HouseType>;
	livesWithWhichFamilyMember?: Maybe<Scalars['String']['output']>;
	otherFamilyDependants?: Maybe<Scalars['Int']['output']>;
	otherFamilyDependantsExplanation?: Maybe<Scalars['String']['output']>;
	transportationMethod?: Maybe<TransportationMethod>;
};

export type RejectMicrocreditRequestInput = {
	microcreditRequestId: Scalars['UUID7']['input'];
	rejectionReason: Scalars['String']['input'];
};

export type RejectMicrocreditRequestPayload = {
	__typename?: 'RejectMicrocreditRequestPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RejectRequestByCreditCommitteeInput = {
	committeeDeliberation: Scalars['String']['input'];
	microcreditRequestId: Scalars['UUID7']['input'];
};

export type RejectRequestByCreditCommitteePayload = {
	__typename?: 'RejectRequestByCreditCommitteePayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditActivityOrBusinessInformationInput = {
	activityDetail?: InputMaybe<Scalars['String']['input']>;
	activityType?: InputMaybe<Scalars['String']['input']>;
	microcreditRequestId: Scalars['UUID7']['input'];
	startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ReviewMicrocreditActivityOrBusinessInformationPayload = {
	__typename?: 'ReviewMicrocreditActivityOrBusinessInformationPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditCallCommentsInput = {
	callComments: Scalars['String']['input'];
	microcreditRequestId: Scalars['UUID7']['input'];
};

export type ReviewMicrocreditCallCommentsPayload = {
	__typename?: 'ReviewMicrocreditCallCommentsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditCreditDetailsInput = {
	amountRequested?: InputMaybe<Scalars['Money']['input']>;
	creditUse?: InputMaybe<Scalars['String']['input']>;
	creditUseDetail?: InputMaybe<Scalars['String']['input']>;
	expectedAdditionalIncome?: InputMaybe<Scalars['Money']['input']>;
	microcreditRequestId: Scalars['UUID7']['input'];
};

export type ReviewMicrocreditCreditDetailsPayload = {
	__typename?: 'ReviewMicrocreditCreditDetailsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditMonthlyBusinessExpensesInput = {
	electricBill?: InputMaybe<Scalars['Money']['input']>;
	equipmentMaintenance?: InputMaybe<Scalars['Money']['input']>;
	gas?: InputMaybe<Scalars['Money']['input']>;
	inputsPurchase?: InputMaybe<Scalars['Money']['input']>;
	internetBill?: InputMaybe<Scalars['Money']['input']>;
	microcreditRequestId: Scalars['UUID7']['input'];
	rent?: InputMaybe<Scalars['Money']['input']>;
	salaries?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewMicrocreditMonthlyBusinessExpensesPayload = {
	__typename?: 'ReviewMicrocreditMonthlyBusinessExpensesPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditMonthlyHouseExpensesInput = {
	electricBill?: InputMaybe<Scalars['Money']['input']>;
	familyExpenses?: InputMaybe<Scalars['Money']['input']>;
	groceries?: InputMaybe<Scalars['Money']['input']>;
	internetBill?: InputMaybe<Scalars['Money']['input']>;
	microcreditRequestId: Scalars['UUID7']['input'];
	rent?: InputMaybe<Scalars['Money']['input']>;
	tuitions?: InputMaybe<Scalars['Money']['input']>;
	waterBill?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewMicrocreditMonthlyHouseExpensesPayload = {
	__typename?: 'ReviewMicrocreditMonthlyHouseExpensesPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditMonthlyIncomeInformationInput = {
	businessSales?: InputMaybe<Scalars['Money']['input']>;
	familyContributionsIncome?: InputMaybe<Scalars['Money']['input']>;
	microcreditRequestId: Scalars['UUID7']['input'];
	otherSourcesIncome?: InputMaybe<Scalars['Money']['input']>;
	otherSourcesIncomeDetail?: InputMaybe<Scalars['String']['input']>;
	salary?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewMicrocreditMonthlyIncomeInformationPayload = {
	__typename?: 'ReviewMicrocreditMonthlyIncomeInformationPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditOtherCreditsInput = {
	currentTotalDebt?: InputMaybe<Scalars['Money']['input']>;
	microcreditRequestId: Scalars['UUID7']['input'];
	monthlyPaymentToCredits?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewMicrocreditOtherCreditsPayload = {
	__typename?: 'ReviewMicrocreditOtherCreditsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditPersonalInformationInput = {
	childDependants?: InputMaybe<Scalars['Int']['input']>;
	houseType?: InputMaybe<HouseType>;
	livesWithWhichFamilyMember?: InputMaybe<Scalars['String']['input']>;
	microcreditRequestId: Scalars['UUID7']['input'];
	otherFamilyDependants?: InputMaybe<Scalars['Int']['input']>;
	otherFamilyDependantsExplanation?: InputMaybe<Scalars['String']['input']>;
	transportationMethod?: InputMaybe<TransportationMethod>;
};

export type ReviewMicrocreditPersonalInformationPayload = {
	__typename?: 'ReviewMicrocreditPersonalInformationPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMicrocreditValueOfAssetsInput = {
	carsValue?: InputMaybe<Scalars['Money']['input']>;
	equipmentDetail?: InputMaybe<Scalars['String']['input']>;
	equipmentValue?: InputMaybe<Scalars['Money']['input']>;
	homeValue?: InputMaybe<Scalars['Money']['input']>;
	landValue?: InputMaybe<Scalars['Money']['input']>;
	microcreditRequestId: Scalars['UUID7']['input'];
	savings?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewMicrocreditValueOfAssetsPayload = {
	__typename?: 'ReviewMicrocreditValueOfAssetsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RootMutationType = {
	__typename?: 'RootMutationType';
	approveRequestByCreditCommittee?: Maybe<ApproveRequestByCreditCommitteePayload>;
	fillEvaluationMatrix?: Maybe<FillEvaluationMatrixPayload>;
	passRequestToCreditCommittee?: Maybe<PassRequestToCreditCommitteePayload>;
	rejectMicrocreditRequest?: Maybe<RejectMicrocreditRequestPayload>;
	rejectRequestByCreditCommittee?: Maybe<RejectRequestByCreditCommitteePayload>;
	reviewMicrocreditActivityOrBusinessInformation?: Maybe<ReviewMicrocreditActivityOrBusinessInformationPayload>;
	reviewMicrocreditCallComments?: Maybe<ReviewMicrocreditCallCommentsPayload>;
	reviewMicrocreditCreditDetails?: Maybe<ReviewMicrocreditCreditDetailsPayload>;
	reviewMicrocreditMonthlyBusinessExpenses?: Maybe<ReviewMicrocreditMonthlyBusinessExpensesPayload>;
	reviewMicrocreditMonthlyHouseExpenses?: Maybe<ReviewMicrocreditMonthlyHouseExpensesPayload>;
	reviewMicrocreditMonthlyIncomeInformation?: Maybe<ReviewMicrocreditMonthlyIncomeInformationPayload>;
	reviewMicrocreditOtherCredits?: Maybe<ReviewMicrocreditOtherCreditsPayload>;
	reviewMicrocreditPersonalInformation?: Maybe<ReviewMicrocreditPersonalInformationPayload>;
	reviewMicrocreditValueOfAssets?: Maybe<ReviewMicrocreditValueOfAssetsPayload>;
	simulateMicrocredit?: Maybe<SimulateMicrocreditPayload>;
};

export type RootMutationTypeApproveRequestByCreditCommitteeArgs = {
	input: ApproveRequestByCreditCommitteeInput;
};

export type RootMutationTypeFillEvaluationMatrixArgs = {
	input: FillEvaluationMatrixInput;
};

export type RootMutationTypePassRequestToCreditCommitteeArgs = {
	input: PassRequestToCreditCommitteeInput;
};

export type RootMutationTypeRejectMicrocreditRequestArgs = {
	input: RejectMicrocreditRequestInput;
};

export type RootMutationTypeRejectRequestByCreditCommitteeArgs = {
	input: RejectRequestByCreditCommitteeInput;
};

export type RootMutationTypeReviewMicrocreditActivityOrBusinessInformationArgs = {
	input: ReviewMicrocreditActivityOrBusinessInformationInput;
};

export type RootMutationTypeReviewMicrocreditCallCommentsArgs = {
	input: ReviewMicrocreditCallCommentsInput;
};

export type RootMutationTypeReviewMicrocreditCreditDetailsArgs = {
	input: ReviewMicrocreditCreditDetailsInput;
};

export type RootMutationTypeReviewMicrocreditMonthlyBusinessExpensesArgs = {
	input: ReviewMicrocreditMonthlyBusinessExpensesInput;
};

export type RootMutationTypeReviewMicrocreditMonthlyHouseExpensesArgs = {
	input: ReviewMicrocreditMonthlyHouseExpensesInput;
};

export type RootMutationTypeReviewMicrocreditMonthlyIncomeInformationArgs = {
	input: ReviewMicrocreditMonthlyIncomeInformationInput;
};

export type RootMutationTypeReviewMicrocreditOtherCreditsArgs = {
	input: ReviewMicrocreditOtherCreditsInput;
};

export type RootMutationTypeReviewMicrocreditPersonalInformationArgs = {
	input: ReviewMicrocreditPersonalInformationInput;
};

export type RootMutationTypeReviewMicrocreditValueOfAssetsArgs = {
	input: ReviewMicrocreditValueOfAssetsInput;
};

export type RootMutationTypeSimulateMicrocreditArgs = {
	input: SimulateMicrocreditInput;
};

export type RootQueryType = {
	__typename?: 'RootQueryType';
	microcreditRequests?: Maybe<MicrocreditRequestConnection>;
	node?: Maybe<Node>;
};

export type RootQueryTypeMicrocreditRequestsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<MicrocreditRequestFilter>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<Array<InputMaybe<MicrocreditRequestSort>>>;
};

export type RootQueryTypeNodeArgs = {
	id: Scalars['ID']['input'];
};

export type SimulateMicrocreditInput = {
	amountRequested: Scalars['Money']['input'];
	daysPerPeriod: DaysPerSimulationPeriod;
	firstPaymentDate: Scalars['Date']['input'];
	microcreditRequestId: Scalars['UUID7']['input'];
	ordinaryInterestRate: Scalars['Decimal']['input'];
	paymentCapacity: Scalars['Money']['input'];
	percentageOfCreditToSettle: Scalars['Decimal']['input'];
	sameDayPayment: Scalars['Boolean']['input'];
};

export type SimulateMicrocreditPayload = {
	__typename?: 'SimulateMicrocreditPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type Simulation = {
	__typename?: 'Simulation';
	configuration?: Maybe<SimulationConfiguration>;
	daysPerPeriod?: Maybe<DaysPerSimulationPeriod>;
	generatedAt?: Maybe<Scalars['DateTime']['output']>;
	installments?: Maybe<Array<Maybe<SimulationInstallment>>>;
	lastPaymentAmount?: Maybe<Scalars['Money']['output']>;
	numberOfPeriods?: Maybe<Scalars['Int']['output']>;
	paymentCapacity?: Maybe<Scalars['Money']['output']>;
};

export type SimulationConfiguration = {
	__typename?: 'SimulationConfiguration';
	amountRequested?: Maybe<Scalars['Money']['output']>;
	daysPerPeriod?: Maybe<Scalars['Int']['output']>;
	firstPaymentDate?: Maybe<Scalars['Date']['output']>;
	highestAmountToApprove?: Maybe<Scalars['Money']['output']>;
	maximumNumberOfPeriods?: Maybe<Scalars['Int']['output']>;
	minimumPaymentToSettleTheCreditPercentage?: Maybe<Scalars['Money']['output']>;
	minimumPaymentToSettleTheCreditTotal?: Maybe<Scalars['Money']['output']>;
	ordinaryInterestRate?: Maybe<Scalars['Decimal']['output']>;
	paymentCapacity?: Maybe<Scalars['Money']['output']>;
	percentageOfCreditToSettle?: Maybe<Scalars['Decimal']['output']>;
	sameDayPayment?: Maybe<Scalars['Boolean']['output']>;
};

export type SimulationInstallment = {
	__typename?: 'SimulationInstallment';
	creditPayment?: Maybe<Scalars['Money']['output']>;
	dueDate?: Maybe<Scalars['Date']['output']>;
	initialBalance?: Maybe<Scalars['Money']['output']>;
	interestPayment?: Maybe<Scalars['Money']['output']>;
	interestTax?: Maybe<Scalars['Money']['output']>;
	outstandingBalance?: Maybe<Scalars['Money']['output']>;
	paymentNumber?: Maybe<Scalars['Int']['output']>;
	principalPayment?: Maybe<Scalars['Money']['output']>;
	totalPayment?: Maybe<Scalars['Money']['output']>;
};

export enum SortDirection {
	/** Ascending */
	ASC = 'ASC',
	/** Descending */
	DESC = 'DESC'
}

export enum TransportationMethod {
	BIKE = 'BIKE',
	CAR = 'CAR',
	PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
	WALK = 'WALK'
}

export type ValueOfAssets = {
	__typename?: 'ValueOfAssets';
	carsValue?: Maybe<Scalars['Money']['output']>;
	equipmentDetail?: Maybe<Scalars['String']['output']>;
	equipmentValue?: Maybe<Scalars['Money']['output']>;
	homeValue?: Maybe<Scalars['Money']['output']>;
	landValue?: Maybe<Scalars['Money']['output']>;
	savings?: Maybe<Scalars['Money']['output']>;
	totalValueOfAssets?: Maybe<Scalars['Money']['output']>;
};

export type SimulateMicrocreditMutationVariables = Exact<{
	input: SimulateMicrocreditInput;
}>;

export type SimulateMicrocreditMutation = {
	__typename?: 'RootMutationType';
	simulateMicrocredit?: {
		__typename?: 'SimulateMicrocreditPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type FillEvaluationMatrixMutationVariables = Exact<{
	input: FillEvaluationMatrixInput;
}>;

export type FillEvaluationMatrixMutation = {
	__typename?: 'RootMutationType';
	fillEvaluationMatrix?: {
		__typename?: 'FillEvaluationMatrixPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditActivityOrBusinessInformationMutationVariables = Exact<{
	input: ReviewMicrocreditActivityOrBusinessInformationInput;
}>;

export type ReviewMicrocreditActivityOrBusinessInformationMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditActivityOrBusinessInformation?: {
		__typename?: 'ReviewMicrocreditActivityOrBusinessInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditCreditDetailsMutationVariables = Exact<{
	input: ReviewMicrocreditCreditDetailsInput;
}>;

export type ReviewMicrocreditCreditDetailsMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditCreditDetails?: {
		__typename?: 'ReviewMicrocreditCreditDetailsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditMonthlyIncomeInformationMutationVariables = Exact<{
	input: ReviewMicrocreditMonthlyIncomeInformationInput;
}>;

export type ReviewMicrocreditMonthlyIncomeInformationMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditMonthlyIncomeInformation?: {
		__typename?: 'ReviewMicrocreditMonthlyIncomeInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditMonthlyBusinessExpensesMutationVariables = Exact<{
	input: ReviewMicrocreditMonthlyBusinessExpensesInput;
}>;

export type ReviewMicrocreditMonthlyBusinessExpensesMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditMonthlyBusinessExpenses?: {
		__typename?: 'ReviewMicrocreditMonthlyBusinessExpensesPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditMonthlyHouseExpensesMutationVariables = Exact<{
	input: ReviewMicrocreditMonthlyHouseExpensesInput;
}>;

export type ReviewMicrocreditMonthlyHouseExpensesMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditMonthlyHouseExpenses?: {
		__typename?: 'ReviewMicrocreditMonthlyHouseExpensesPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditOtherCreditsMutationVariables = Exact<{
	input: ReviewMicrocreditOtherCreditsInput;
}>;

export type ReviewMicrocreditOtherCreditsMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditOtherCredits?: {
		__typename?: 'ReviewMicrocreditOtherCreditsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditValueOfAssetsMutationVariables = Exact<{
	input: ReviewMicrocreditValueOfAssetsInput;
}>;

export type ReviewMicrocreditValueOfAssetsMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditValueOfAssets?: {
		__typename?: 'ReviewMicrocreditValueOfAssetsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditPersonalInformationMutationVariables = Exact<{
	input: ReviewMicrocreditPersonalInformationInput;
}>;

export type ReviewMicrocreditPersonalInformationMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditPersonalInformation?: {
		__typename?: 'ReviewMicrocreditPersonalInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ReviewMicrocreditCallCommentsMutationVariables = Exact<{
	input: ReviewMicrocreditCallCommentsInput;
}>;

export type ReviewMicrocreditCallCommentsMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditCallComments?: {
		__typename?: 'ReviewMicrocreditCallCommentsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type RejectMicrocreditRequestMutationVariables = Exact<{
	input: RejectMicrocreditRequestInput;
}>;

export type RejectMicrocreditRequestMutation = {
	__typename?: 'RootMutationType';
	rejectMicrocreditRequest?: {
		__typename?: 'RejectMicrocreditRequestPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type MicrocreditReviewMutationVariables = Exact<{
	callCommentsInput: ReviewMicrocreditCallCommentsInput;
	personalInformationInput: ReviewMicrocreditPersonalInformationInput;
	monthlyIncomeInformationInput: ReviewMicrocreditMonthlyIncomeInformationInput;
	monthlyHouseExpensesInput: ReviewMicrocreditMonthlyHouseExpensesInput;
	monthlyBusinessExpensesInput: ReviewMicrocreditMonthlyBusinessExpensesInput;
	otherCreditsInput: ReviewMicrocreditOtherCreditsInput;
	activityOrBusinessInformationInput: ReviewMicrocreditActivityOrBusinessInformationInput;
	creditDetailsInput: ReviewMicrocreditCreditDetailsInput;
	valueOfAssetsInput: ReviewMicrocreditValueOfAssetsInput;
}>;

export type MicrocreditReviewMutation = {
	__typename?: 'RootMutationType';
	reviewMicrocreditCallComments?: {
		__typename?: 'ReviewMicrocreditCallCommentsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMicrocreditPersonalInformation?: {
		__typename?: 'ReviewMicrocreditPersonalInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMicrocreditMonthlyIncomeInformation?: {
		__typename?: 'ReviewMicrocreditMonthlyIncomeInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMicrocreditMonthlyHouseExpenses?: {
		__typename?: 'ReviewMicrocreditMonthlyHouseExpensesPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMicrocreditMonthlyBusinessExpenses?: {
		__typename?: 'ReviewMicrocreditMonthlyBusinessExpensesPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMicrocreditOtherCredits?: {
		__typename?: 'ReviewMicrocreditOtherCreditsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMicrocreditActivityOrBusinessInformation?: {
		__typename?: 'ReviewMicrocreditActivityOrBusinessInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMicrocreditCreditDetails?: {
		__typename?: 'ReviewMicrocreditCreditDetailsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMicrocreditValueOfAssets?: {
		__typename?: 'ReviewMicrocreditValueOfAssetsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type PassRequestToCommitteeMutationVariables = Exact<{
	input: PassRequestToCreditCommitteeInput;
}>;

export type PassRequestToCommitteeMutation = {
	__typename?: 'RootMutationType';
	passRequestToCreditCommittee?: {
		__typename?: 'PassRequestToCreditCommitteePayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ApproveRequestByCreditCommitteeMutationVariables = Exact<{
	input: ApproveRequestByCreditCommitteeInput;
}>;

export type ApproveRequestByCreditCommitteeMutation = {
	__typename?: 'RootMutationType';
	approveRequestByCreditCommittee?: {
		__typename?: 'ApproveRequestByCreditCommitteePayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type RejectRequestByCreditCommitteeMutationVariables = Exact<{
	input: RejectRequestByCreditCommitteeInput;
}>;

export type RejectRequestByCreditCommitteeMutation = {
	__typename?: 'RootMutationType';
	rejectRequestByCreditCommittee?: {
		__typename?: 'RejectRequestByCreditCommitteePayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type GetMicrocreditRequestQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetMicrocreditRequestQuery = {
	__typename?: 'RootQueryType';
	node?: {
		__typename?: 'MicrocreditRequest';
		id: string;
		microcreditRequestId?: string | null;
		clientId?: string | null;
		names?: string | null;
		firstLastName?: string | null;
		secondLastName?: string | null;
		email?: string | null;
		phoneNumber?: string | null;
		microcreditRequestStatus?: MicrocreditRequestStatus | null;
		calculatedNetIncome?: string | null;
		calculatedNetIncomeIndex?: string | null;
		recoveryTimeInYears?: string | null;
		economicSolvencyIi?: string | null;
		startedAt?: string | null;
		onboardingStatus?: OnboardingStatus | null;
		onboardingRegistryDeliberation?: string | null;
		callComments?: string | null;
		rejectionReason?: string | null;
		creditAreaOpinion?: string | null;
		applicantComprehensiveOperativeEfficiency?: string | null;
		businessComprehensiveOperativeEfficiency?: string | null;
		committeeDeliberation?: string | null;
		committeeRequestedChanges?: string | null;
		committeeRuling?: CommitteeRuling | null;
		personalInformation?: {
			__typename?: 'PersonalInformation';
			houseType?: HouseType | null;
			livesWithWhichFamilyMember?: string | null;
			transportationMethod?: TransportationMethod | null;
			childDependants?: number | null;
			otherFamilyDependants?: number | null;
			otherFamilyDependantsExplanation?: string | null;
		} | null;
		activityOrBusinessInformation?: {
			__typename?: 'ActivityOrBusinessInformation';
			activityType?: string | null;
			startDate?: string | null;
			activityDetail?: string | null;
			operatingTimeRange?: OperatingTimeRanges | null;
		} | null;
		creditDetails?: {
			__typename?: 'CreditDetails';
			creditUse?: string | null;
			creditUseDetail?: string | null;
			amountRequested?: string | null;
			expectedAdditionalIncome?: string | null;
		} | null;
		monthlyIncomeInformation?: {
			__typename?: 'MonthlyIncomeInformation';
			businessSales?: string | null;
			salary?: string | null;
			familyContributionsIncome?: string | null;
			otherSourcesIncome?: string | null;
			otherSourcesIncomeDetail?: string | null;
			totalIncome?: string | null;
		} | null;
		monthlyBusinessExpenses?: {
			__typename?: 'MonthlyBusinessExpenses';
			rent?: string | null;
			electricBill?: string | null;
			internetBill?: string | null;
			equipmentMaintenance?: string | null;
			inputsPurchase?: string | null;
			salaries?: string | null;
			gas?: string | null;
			totalBusinessExpenses?: string | null;
		} | null;
		monthlyHouseExpenses?: {
			__typename?: 'MonthlyHouseExpenses';
			rent?: string | null;
			electricBill?: string | null;
			internetBill?: string | null;
			waterBill?: string | null;
			groceries?: string | null;
			tuitions?: string | null;
			familyExpenses?: string | null;
			totalHouseExpenses?: string | null;
		} | null;
		valueOfAssets?: {
			__typename?: 'ValueOfAssets';
			homeValue?: string | null;
			landValue?: string | null;
			carsValue?: string | null;
			equipmentValue?: string | null;
			equipmentDetail?: string | null;
			savings?: string | null;
			totalValueOfAssets?: string | null;
		} | null;
		otherCredits?: {
			__typename?: 'OtherCredits';
			currentTotalDebt?: string | null;
			monthlyPaymentToCredits?: string | null;
		} | null;
		creditBureauReport?: {
			__typename?: 'CreditBureauReport';
			reportDate?: string | null;
			firstCreditDate?: string | null;
			oldestDuePayment?: OldestDuePayment | null;
			totalCreditBalance?: string | null;
			totalActiveCreditBalance?: string | null;
			totalNumberOfCredits?: number | null;
			totalActiveNumberOfCredits?: number | null;
			creditBureauScore?: number | null;
		} | null;
		evaluationMatrix?: {
			__typename?: 'EvaluationMatrix';
			applicantPaymentExperienceI?: ApplicantPaymentExperienceI | null;
			applicantPaymentExperienceIi?: ApplicantPaymentExperienceIi | null;
			economicSolvencyIi?: EconomicSolvencyIi | null;
			familyMemberPaymentExperienceIi?: FamilyMemberPaymentExperienceIi | null;
			applicantNetIncomeIndex?: ApplicantNetIncomeIndex | null;
			totalScore?: number | null;
		} | null;
		simulation?: {
			__typename?: 'Simulation';
			numberOfPeriods?: number | null;
			daysPerPeriod?: DaysPerSimulationPeriod | null;
			paymentCapacity?: string | null;
			generatedAt?: string | null;
			lastPaymentAmount?: string | null;
			configuration?: {
				__typename?: 'SimulationConfiguration';
				amountRequested?: string | null;
				paymentCapacity?: string | null;
				daysPerPeriod?: number | null;
				maximumNumberOfPeriods?: number | null;
				ordinaryInterestRate?: string | null;
				firstPaymentDate?: string | null;
				sameDayPayment?: boolean | null;
				percentageOfCreditToSettle?: string | null;
				highestAmountToApprove?: string | null;
				minimumPaymentToSettleTheCreditTotal?: string | null;
				minimumPaymentToSettleTheCreditPercentage?: string | null;
			} | null;
			installments?: Array<{
				__typename?: 'SimulationInstallment';
				paymentNumber?: number | null;
				dueDate?: string | null;
				initialBalance?: string | null;
				creditPayment?: string | null;
				principalPayment?: string | null;
				interestPayment?: string | null;
				interestTax?: string | null;
				totalPayment?: string | null;
				outstandingBalance?: string | null;
			} | null> | null;
		} | null;
	} | null;
};

export type GetMicrocreditRequestBasicQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetMicrocreditRequestBasicQuery = {
	__typename?: 'RootQueryType';
	node?: {
		__typename?: 'MicrocreditRequest';
		id: string;
		microcreditRequestId?: string | null;
		clientId?: string | null;
		names?: string | null;
		firstLastName?: string | null;
		secondLastName?: string | null;
		email?: string | null;
		phoneNumber?: string | null;
		microcreditRequestStatus?: MicrocreditRequestStatus | null;
		calculatedNetIncome?: string | null;
		startedAt?: string | null;
		onboardingStatus?: OnboardingStatus | null;
		creditDetails?: { __typename?: 'CreditDetails'; amountRequested?: string | null } | null;
		evaluationMatrix?: { __typename?: 'EvaluationMatrix'; totalScore?: number | null } | null;
	} | null;
};

export type MicrocreditRequestsQueryVariables = Exact<{
	after?: InputMaybe<Scalars['String']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<
		Array<InputMaybe<MicrocreditRequestSort>> | InputMaybe<MicrocreditRequestSort>
	>;
	filter?: InputMaybe<MicrocreditRequestFilter>;
}>;

export type MicrocreditRequestsQuery = {
	__typename?: 'RootQueryType';
	microcreditRequests?: {
		__typename?: 'MicrocreditRequestConnection';
		count?: number | null;
		pageInfo: {
			__typename?: 'PageInfo';
			hasPreviousPage: boolean;
			hasNextPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		};
		edges?: Array<{
			__typename?: 'MicrocreditRequestEdge';
			cursor?: string | null;
			node?: {
				__typename?: 'MicrocreditRequest';
				id: string;
				onboardingStatus?: OnboardingStatus | null;
				microcreditRequestStatus?: MicrocreditRequestStatus | null;
				clientId?: string | null;
				microcreditRequestId?: string | null;
				names?: string | null;
				firstLastName?: string | null;
				secondLastName?: string | null;
				phoneNumber?: string | null;
				email?: string | null;
				startedAt?: string | null;
				creditDetails?: { __typename?: 'CreditDetails'; amountRequested?: string | null } | null;
			} | null;
		} | null> | null;
	} | null;
};

export type MicrocreditRequestsByStatusQueryVariables = Exact<{
	status?: InputMaybe<
		Array<InputMaybe<MicrocreditRequestStatus>> | InputMaybe<MicrocreditRequestStatus>
	>;
	onboardingStatus?: InputMaybe<Array<InputMaybe<OnboardingStatus>> | InputMaybe<OnboardingStatus>>;
	first?: InputMaybe<Scalars['Int']['input']>;
	after?: InputMaybe<Scalars['String']['input']>;
}>;

export type MicrocreditRequestsByStatusQuery = {
	__typename?: 'RootQueryType';
	microcreditRequests?: {
		__typename?: 'MicrocreditRequestConnection';
		count?: number | null;
		pageInfo: {
			__typename?: 'PageInfo';
			hasPreviousPage: boolean;
			hasNextPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		};
		edges?: Array<{
			__typename?: 'MicrocreditRequestEdge';
			cursor?: string | null;
			node?: {
				__typename?: 'MicrocreditRequest';
				id: string;
				microcreditRequestId?: string | null;
				names?: string | null;
				firstLastName?: string | null;
				secondLastName?: string | null;
				microcreditRequestStatus?: MicrocreditRequestStatus | null;
				onboardingStatus?: OnboardingStatus | null;
				startedAt?: string | null;
				calculatedNetIncome?: string | null;
				creditDetails?: { __typename?: 'CreditDetails'; amountRequested?: string | null } | null;
				evaluationMatrix?: { __typename?: 'EvaluationMatrix'; totalScore?: number | null } | null;
			} | null;
		} | null> | null;
	} | null;
};

export type SearchMicrocreditRequestsQueryVariables = Exact<{
	searchTerm: Scalars['String']['input'];
	first?: InputMaybe<Scalars['Int']['input']>;
	after?: InputMaybe<Scalars['String']['input']>;
}>;

export type SearchMicrocreditRequestsQuery = {
	__typename?: 'RootQueryType';
	microcreditRequests?: {
		__typename?: 'MicrocreditRequestConnection';
		count?: number | null;
		pageInfo: {
			__typename?: 'PageInfo';
			hasPreviousPage: boolean;
			hasNextPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		};
		edges?: Array<{
			__typename?: 'MicrocreditRequestEdge';
			cursor?: string | null;
			node?: {
				__typename?: 'MicrocreditRequest';
				id: string;
				microcreditRequestId?: string | null;
				names?: string | null;
				firstLastName?: string | null;
				secondLastName?: string | null;
				email?: string | null;
				phoneNumber?: string | null;
				microcreditRequestStatus?: MicrocreditRequestStatus | null;
				onboardingStatus?: OnboardingStatus | null;
				startedAt?: string | null;
				creditDetails?: { __typename?: 'CreditDetails'; amountRequested?: string | null } | null;
			} | null;
		} | null> | null;
	} | null;
};

export type MicrocreditRequestsByDateRangeQueryVariables = Exact<{
	from?: InputMaybe<Scalars['DateTime']['input']>;
	to?: InputMaybe<Scalars['DateTime']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	after?: InputMaybe<Scalars['String']['input']>;
}>;

export type MicrocreditRequestsByDateRangeQuery = {
	__typename?: 'RootQueryType';
	microcreditRequests?: {
		__typename?: 'MicrocreditRequestConnection';
		count?: number | null;
		pageInfo: {
			__typename?: 'PageInfo';
			hasPreviousPage: boolean;
			hasNextPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		};
		edges?: Array<{
			__typename?: 'MicrocreditRequestEdge';
			cursor?: string | null;
			node?: {
				__typename?: 'MicrocreditRequest';
				id: string;
				microcreditRequestId?: string | null;
				names?: string | null;
				firstLastName?: string | null;
				secondLastName?: string | null;
				microcreditRequestStatus?: MicrocreditRequestStatus | null;
				onboardingStatus?: OnboardingStatus | null;
				startedAt?: string | null;
				calculatedNetIncome?: string | null;
				recoveryTimeInYears?: string | null;
				economicSolvencyIi?: string | null;
				creditDetails?: { __typename?: 'CreditDetails'; amountRequested?: string | null } | null;
			} | null;
		} | null> | null;
	} | null;
};

export type GetEvaluationMatrixQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetEvaluationMatrixQuery = {
	__typename?: 'RootQueryType';
	node?: {
		__typename?: 'MicrocreditRequest';
		id: string;
		microcreditRequestId?: string | null;
		calculatedNetIncome?: string | null;
		calculatedNetIncomeIndex?: string | null;
		recoveryTimeInYears?: string | null;
		economicSolvencyIi?: string | null;
		evaluationMatrix?: {
			__typename?: 'EvaluationMatrix';
			applicantPaymentExperienceI?: ApplicantPaymentExperienceI | null;
			applicantPaymentExperienceIi?: ApplicantPaymentExperienceIi | null;
			familyMemberPaymentExperienceIi?: FamilyMemberPaymentExperienceIi | null;
			economicSolvencyIi?: EconomicSolvencyIi | null;
			applicantNetIncomeIndex?: ApplicantNetIncomeIndex | null;
			totalScore?: number | null;
		} | null;
	} | null;
};

export type GetSimulationDetailsQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetSimulationDetailsQuery = {
	__typename?: 'RootQueryType';
	node?: {
		__typename?: 'MicrocreditRequest';
		id: string;
		microcreditRequestId?: string | null;
		simulation?: {
			__typename?: 'Simulation';
			numberOfPeriods?: number | null;
			daysPerPeriod?: DaysPerSimulationPeriod | null;
			paymentCapacity?: string | null;
			lastPaymentAmount?: string | null;
			generatedAt?: string | null;
			configuration?: {
				__typename?: 'SimulationConfiguration';
				amountRequested?: string | null;
				paymentCapacity?: string | null;
				daysPerPeriod?: number | null;
				maximumNumberOfPeriods?: number | null;
				ordinaryInterestRate?: string | null;
				firstPaymentDate?: string | null;
				sameDayPayment?: boolean | null;
				percentageOfCreditToSettle?: string | null;
				highestAmountToApprove?: string | null;
				minimumPaymentToSettleTheCreditTotal?: string | null;
				minimumPaymentToSettleTheCreditPercentage?: string | null;
			} | null;
			installments?: Array<{
				__typename?: 'SimulationInstallment';
				paymentNumber?: number | null;
				dueDate?: string | null;
				initialBalance?: string | null;
				creditPayment?: string | null;
				principalPayment?: string | null;
				interestPayment?: string | null;
				interestTax?: string | null;
				totalPayment?: string | null;
				outstandingBalance?: string | null;
			} | null> | null;
		} | null;
	} | null;
};

export const SimulateMicrocreditDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'SimulateMicrocredit' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulateMicrocreditInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'simulateMicrocredit' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type SimulateMicrocreditMutationFn = Apollo.MutationFunction<
	SimulateMicrocreditMutation,
	SimulateMicrocreditMutationVariables
>;

/**
 * __useSimulateMicrocreditMutation__
 *
 * To run a mutation, you first call `useSimulateMicrocreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateMicrocreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateMicrocreditMutation, { data, loading, error }] = useSimulateMicrocreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateMicrocreditMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SimulateMicrocreditMutation,
		SimulateMicrocreditMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SimulateMicrocreditMutation, SimulateMicrocreditMutationVariables>(
		SimulateMicrocreditDocument,
		options
	);
}
export type SimulateMicrocreditMutationHookResult = ReturnType<
	typeof useSimulateMicrocreditMutation
>;
export type SimulateMicrocreditMutationResult = Apollo.MutationResult<SimulateMicrocreditMutation>;
export type SimulateMicrocreditMutationOptions = Apollo.BaseMutationOptions<
	SimulateMicrocreditMutation,
	SimulateMicrocreditMutationVariables
>;
export const FillEvaluationMatrixDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'FillEvaluationMatrix' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'FillEvaluationMatrixInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'fillEvaluationMatrix' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type FillEvaluationMatrixMutationFn = Apollo.MutationFunction<
	FillEvaluationMatrixMutation,
	FillEvaluationMatrixMutationVariables
>;

/**
 * __useFillEvaluationMatrixMutation__
 *
 * To run a mutation, you first call `useFillEvaluationMatrixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillEvaluationMatrixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillEvaluationMatrixMutation, { data, loading, error }] = useFillEvaluationMatrixMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillEvaluationMatrixMutation(
	baseOptions?: Apollo.MutationHookOptions<
		FillEvaluationMatrixMutation,
		FillEvaluationMatrixMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<FillEvaluationMatrixMutation, FillEvaluationMatrixMutationVariables>(
		FillEvaluationMatrixDocument,
		options
	);
}
export type FillEvaluationMatrixMutationHookResult = ReturnType<
	typeof useFillEvaluationMatrixMutation
>;
export type FillEvaluationMatrixMutationResult =
	Apollo.MutationResult<FillEvaluationMatrixMutation>;
export type FillEvaluationMatrixMutationOptions = Apollo.BaseMutationOptions<
	FillEvaluationMatrixMutation,
	FillEvaluationMatrixMutationVariables
>;
export const ReviewMicrocreditActivityOrBusinessInformationDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditActivityOrBusinessInformation' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditActivityOrBusinessInformationInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditActivityOrBusinessInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditActivityOrBusinessInformationMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditActivityOrBusinessInformationMutation,
	ReviewMicrocreditActivityOrBusinessInformationMutationVariables
>;

/**
 * __useReviewMicrocreditActivityOrBusinessInformationMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditActivityOrBusinessInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditActivityOrBusinessInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditActivityOrBusinessInformationMutation, { data, loading, error }] = useReviewMicrocreditActivityOrBusinessInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditActivityOrBusinessInformationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditActivityOrBusinessInformationMutation,
		ReviewMicrocreditActivityOrBusinessInformationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditActivityOrBusinessInformationMutation,
		ReviewMicrocreditActivityOrBusinessInformationMutationVariables
	>(ReviewMicrocreditActivityOrBusinessInformationDocument, options);
}
export type ReviewMicrocreditActivityOrBusinessInformationMutationHookResult = ReturnType<
	typeof useReviewMicrocreditActivityOrBusinessInformationMutation
>;
export type ReviewMicrocreditActivityOrBusinessInformationMutationResult =
	Apollo.MutationResult<ReviewMicrocreditActivityOrBusinessInformationMutation>;
export type ReviewMicrocreditActivityOrBusinessInformationMutationOptions =
	Apollo.BaseMutationOptions<
		ReviewMicrocreditActivityOrBusinessInformationMutation,
		ReviewMicrocreditActivityOrBusinessInformationMutationVariables
	>;
export const ReviewMicrocreditCreditDetailsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditCreditDetails' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditCreditDetailsInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditCreditDetails' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditCreditDetailsMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditCreditDetailsMutation,
	ReviewMicrocreditCreditDetailsMutationVariables
>;

/**
 * __useReviewMicrocreditCreditDetailsMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditCreditDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditCreditDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditCreditDetailsMutation, { data, loading, error }] = useReviewMicrocreditCreditDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditCreditDetailsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditCreditDetailsMutation,
		ReviewMicrocreditCreditDetailsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditCreditDetailsMutation,
		ReviewMicrocreditCreditDetailsMutationVariables
	>(ReviewMicrocreditCreditDetailsDocument, options);
}
export type ReviewMicrocreditCreditDetailsMutationHookResult = ReturnType<
	typeof useReviewMicrocreditCreditDetailsMutation
>;
export type ReviewMicrocreditCreditDetailsMutationResult =
	Apollo.MutationResult<ReviewMicrocreditCreditDetailsMutation>;
export type ReviewMicrocreditCreditDetailsMutationOptions = Apollo.BaseMutationOptions<
	ReviewMicrocreditCreditDetailsMutation,
	ReviewMicrocreditCreditDetailsMutationVariables
>;
export const ReviewMicrocreditMonthlyIncomeInformationDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyIncomeInformation' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyIncomeInformationInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditMonthlyIncomeInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditMonthlyIncomeInformationMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditMonthlyIncomeInformationMutation,
	ReviewMicrocreditMonthlyIncomeInformationMutationVariables
>;

/**
 * __useReviewMicrocreditMonthlyIncomeInformationMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditMonthlyIncomeInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditMonthlyIncomeInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditMonthlyIncomeInformationMutation, { data, loading, error }] = useReviewMicrocreditMonthlyIncomeInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditMonthlyIncomeInformationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditMonthlyIncomeInformationMutation,
		ReviewMicrocreditMonthlyIncomeInformationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditMonthlyIncomeInformationMutation,
		ReviewMicrocreditMonthlyIncomeInformationMutationVariables
	>(ReviewMicrocreditMonthlyIncomeInformationDocument, options);
}
export type ReviewMicrocreditMonthlyIncomeInformationMutationHookResult = ReturnType<
	typeof useReviewMicrocreditMonthlyIncomeInformationMutation
>;
export type ReviewMicrocreditMonthlyIncomeInformationMutationResult =
	Apollo.MutationResult<ReviewMicrocreditMonthlyIncomeInformationMutation>;
export type ReviewMicrocreditMonthlyIncomeInformationMutationOptions = Apollo.BaseMutationOptions<
	ReviewMicrocreditMonthlyIncomeInformationMutation,
	ReviewMicrocreditMonthlyIncomeInformationMutationVariables
>;
export const ReviewMicrocreditMonthlyBusinessExpensesDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyBusinessExpenses' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyBusinessExpensesInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditMonthlyBusinessExpenses' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditMonthlyBusinessExpensesMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditMonthlyBusinessExpensesMutation,
	ReviewMicrocreditMonthlyBusinessExpensesMutationVariables
>;

/**
 * __useReviewMicrocreditMonthlyBusinessExpensesMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditMonthlyBusinessExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditMonthlyBusinessExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditMonthlyBusinessExpensesMutation, { data, loading, error }] = useReviewMicrocreditMonthlyBusinessExpensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditMonthlyBusinessExpensesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditMonthlyBusinessExpensesMutation,
		ReviewMicrocreditMonthlyBusinessExpensesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditMonthlyBusinessExpensesMutation,
		ReviewMicrocreditMonthlyBusinessExpensesMutationVariables
	>(ReviewMicrocreditMonthlyBusinessExpensesDocument, options);
}
export type ReviewMicrocreditMonthlyBusinessExpensesMutationHookResult = ReturnType<
	typeof useReviewMicrocreditMonthlyBusinessExpensesMutation
>;
export type ReviewMicrocreditMonthlyBusinessExpensesMutationResult =
	Apollo.MutationResult<ReviewMicrocreditMonthlyBusinessExpensesMutation>;
export type ReviewMicrocreditMonthlyBusinessExpensesMutationOptions = Apollo.BaseMutationOptions<
	ReviewMicrocreditMonthlyBusinessExpensesMutation,
	ReviewMicrocreditMonthlyBusinessExpensesMutationVariables
>;
export const ReviewMicrocreditMonthlyHouseExpensesDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyHouseExpenses' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyHouseExpensesInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditMonthlyHouseExpenses' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditMonthlyHouseExpensesMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditMonthlyHouseExpensesMutation,
	ReviewMicrocreditMonthlyHouseExpensesMutationVariables
>;

/**
 * __useReviewMicrocreditMonthlyHouseExpensesMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditMonthlyHouseExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditMonthlyHouseExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditMonthlyHouseExpensesMutation, { data, loading, error }] = useReviewMicrocreditMonthlyHouseExpensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditMonthlyHouseExpensesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditMonthlyHouseExpensesMutation,
		ReviewMicrocreditMonthlyHouseExpensesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditMonthlyHouseExpensesMutation,
		ReviewMicrocreditMonthlyHouseExpensesMutationVariables
	>(ReviewMicrocreditMonthlyHouseExpensesDocument, options);
}
export type ReviewMicrocreditMonthlyHouseExpensesMutationHookResult = ReturnType<
	typeof useReviewMicrocreditMonthlyHouseExpensesMutation
>;
export type ReviewMicrocreditMonthlyHouseExpensesMutationResult =
	Apollo.MutationResult<ReviewMicrocreditMonthlyHouseExpensesMutation>;
export type ReviewMicrocreditMonthlyHouseExpensesMutationOptions = Apollo.BaseMutationOptions<
	ReviewMicrocreditMonthlyHouseExpensesMutation,
	ReviewMicrocreditMonthlyHouseExpensesMutationVariables
>;
export const ReviewMicrocreditOtherCreditsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditOtherCredits' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditOtherCreditsInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditOtherCredits' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditOtherCreditsMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditOtherCreditsMutation,
	ReviewMicrocreditOtherCreditsMutationVariables
>;

/**
 * __useReviewMicrocreditOtherCreditsMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditOtherCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditOtherCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditOtherCreditsMutation, { data, loading, error }] = useReviewMicrocreditOtherCreditsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditOtherCreditsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditOtherCreditsMutation,
		ReviewMicrocreditOtherCreditsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditOtherCreditsMutation,
		ReviewMicrocreditOtherCreditsMutationVariables
	>(ReviewMicrocreditOtherCreditsDocument, options);
}
export type ReviewMicrocreditOtherCreditsMutationHookResult = ReturnType<
	typeof useReviewMicrocreditOtherCreditsMutation
>;
export type ReviewMicrocreditOtherCreditsMutationResult =
	Apollo.MutationResult<ReviewMicrocreditOtherCreditsMutation>;
export type ReviewMicrocreditOtherCreditsMutationOptions = Apollo.BaseMutationOptions<
	ReviewMicrocreditOtherCreditsMutation,
	ReviewMicrocreditOtherCreditsMutationVariables
>;
export const ReviewMicrocreditValueOfAssetsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditValueOfAssets' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditValueOfAssetsInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditValueOfAssets' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditValueOfAssetsMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditValueOfAssetsMutation,
	ReviewMicrocreditValueOfAssetsMutationVariables
>;

/**
 * __useReviewMicrocreditValueOfAssetsMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditValueOfAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditValueOfAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditValueOfAssetsMutation, { data, loading, error }] = useReviewMicrocreditValueOfAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditValueOfAssetsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditValueOfAssetsMutation,
		ReviewMicrocreditValueOfAssetsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditValueOfAssetsMutation,
		ReviewMicrocreditValueOfAssetsMutationVariables
	>(ReviewMicrocreditValueOfAssetsDocument, options);
}
export type ReviewMicrocreditValueOfAssetsMutationHookResult = ReturnType<
	typeof useReviewMicrocreditValueOfAssetsMutation
>;
export type ReviewMicrocreditValueOfAssetsMutationResult =
	Apollo.MutationResult<ReviewMicrocreditValueOfAssetsMutation>;
export type ReviewMicrocreditValueOfAssetsMutationOptions = Apollo.BaseMutationOptions<
	ReviewMicrocreditValueOfAssetsMutation,
	ReviewMicrocreditValueOfAssetsMutationVariables
>;
export const ReviewMicrocreditPersonalInformationDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditPersonalInformation' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditPersonalInformationInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditPersonalInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditPersonalInformationMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditPersonalInformationMutation,
	ReviewMicrocreditPersonalInformationMutationVariables
>;

/**
 * __useReviewMicrocreditPersonalInformationMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditPersonalInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditPersonalInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditPersonalInformationMutation, { data, loading, error }] = useReviewMicrocreditPersonalInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditPersonalInformationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditPersonalInformationMutation,
		ReviewMicrocreditPersonalInformationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditPersonalInformationMutation,
		ReviewMicrocreditPersonalInformationMutationVariables
	>(ReviewMicrocreditPersonalInformationDocument, options);
}
export type ReviewMicrocreditPersonalInformationMutationHookResult = ReturnType<
	typeof useReviewMicrocreditPersonalInformationMutation
>;
export type ReviewMicrocreditPersonalInformationMutationResult =
	Apollo.MutationResult<ReviewMicrocreditPersonalInformationMutation>;
export type ReviewMicrocreditPersonalInformationMutationOptions = Apollo.BaseMutationOptions<
	ReviewMicrocreditPersonalInformationMutation,
	ReviewMicrocreditPersonalInformationMutationVariables
>;
export const ReviewMicrocreditCallCommentsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ReviewMicrocreditCallComments' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditCallCommentsInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditCallComments' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ReviewMicrocreditCallCommentsMutationFn = Apollo.MutationFunction<
	ReviewMicrocreditCallCommentsMutation,
	ReviewMicrocreditCallCommentsMutationVariables
>;

/**
 * __useReviewMicrocreditCallCommentsMutation__
 *
 * To run a mutation, you first call `useReviewMicrocreditCallCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMicrocreditCallCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMicrocreditCallCommentsMutation, { data, loading, error }] = useReviewMicrocreditCallCommentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMicrocreditCallCommentsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReviewMicrocreditCallCommentsMutation,
		ReviewMicrocreditCallCommentsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReviewMicrocreditCallCommentsMutation,
		ReviewMicrocreditCallCommentsMutationVariables
	>(ReviewMicrocreditCallCommentsDocument, options);
}
export type ReviewMicrocreditCallCommentsMutationHookResult = ReturnType<
	typeof useReviewMicrocreditCallCommentsMutation
>;
export type ReviewMicrocreditCallCommentsMutationResult =
	Apollo.MutationResult<ReviewMicrocreditCallCommentsMutation>;
export type ReviewMicrocreditCallCommentsMutationOptions = Apollo.BaseMutationOptions<
	ReviewMicrocreditCallCommentsMutation,
	ReviewMicrocreditCallCommentsMutationVariables
>;
export const RejectMicrocreditRequestDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RejectMicrocreditRequest' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'RejectMicrocreditRequestInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rejectMicrocreditRequest' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RejectMicrocreditRequestMutationFn = Apollo.MutationFunction<
	RejectMicrocreditRequestMutation,
	RejectMicrocreditRequestMutationVariables
>;

/**
 * __useRejectMicrocreditRequestMutation__
 *
 * To run a mutation, you first call `useRejectMicrocreditRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectMicrocreditRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectMicrocreditRequestMutation, { data, loading, error }] = useRejectMicrocreditRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectMicrocreditRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectMicrocreditRequestMutation,
		RejectMicrocreditRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectMicrocreditRequestMutation,
		RejectMicrocreditRequestMutationVariables
	>(RejectMicrocreditRequestDocument, options);
}
export type RejectMicrocreditRequestMutationHookResult = ReturnType<
	typeof useRejectMicrocreditRequestMutation
>;
export type RejectMicrocreditRequestMutationResult =
	Apollo.MutationResult<RejectMicrocreditRequestMutation>;
export type RejectMicrocreditRequestMutationOptions = Apollo.BaseMutationOptions<
	RejectMicrocreditRequestMutation,
	RejectMicrocreditRequestMutationVariables
>;
export const MicrocreditReviewDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'MicrocreditReview' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'callCommentsInput' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditCallCommentsInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'personalInformationInput' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditPersonalInformationInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'monthlyIncomeInformationInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyIncomeInformationInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'monthlyHouseExpensesInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyHouseExpensesInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'monthlyBusinessExpensesInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditMonthlyBusinessExpensesInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'otherCreditsInput' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditOtherCreditsInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'activityOrBusinessInformationInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditActivityOrBusinessInformationInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'creditDetailsInput' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditCreditDetailsInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'valueOfAssetsInput' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMicrocreditValueOfAssetsInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditCallComments' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'callCommentsInput' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditPersonalInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'personalInformationInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditMonthlyIncomeInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'monthlyIncomeInformationInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditMonthlyHouseExpenses' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'monthlyHouseExpensesInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditMonthlyBusinessExpenses' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'monthlyBusinessExpensesInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditOtherCredits' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'otherCreditsInput' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditActivityOrBusinessInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'activityOrBusinessInformationInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditCreditDetails' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'creditDetailsInput' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMicrocreditValueOfAssets' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'valueOfAssetsInput' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type MicrocreditReviewMutationFn = Apollo.MutationFunction<
	MicrocreditReviewMutation,
	MicrocreditReviewMutationVariables
>;

/**
 * __useMicrocreditReviewMutation__
 *
 * To run a mutation, you first call `useMicrocreditReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMicrocreditReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [microcreditReviewMutation, { data, loading, error }] = useMicrocreditReviewMutation({
 *   variables: {
 *      callCommentsInput: // value for 'callCommentsInput'
 *      personalInformationInput: // value for 'personalInformationInput'
 *      monthlyIncomeInformationInput: // value for 'monthlyIncomeInformationInput'
 *      monthlyHouseExpensesInput: // value for 'monthlyHouseExpensesInput'
 *      monthlyBusinessExpensesInput: // value for 'monthlyBusinessExpensesInput'
 *      otherCreditsInput: // value for 'otherCreditsInput'
 *      activityOrBusinessInformationInput: // value for 'activityOrBusinessInformationInput'
 *      creditDetailsInput: // value for 'creditDetailsInput'
 *      valueOfAssetsInput: // value for 'valueOfAssetsInput'
 *   },
 * });
 */
export function useMicrocreditReviewMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MicrocreditReviewMutation,
		MicrocreditReviewMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MicrocreditReviewMutation, MicrocreditReviewMutationVariables>(
		MicrocreditReviewDocument,
		options
	);
}
export type MicrocreditReviewMutationHookResult = ReturnType<typeof useMicrocreditReviewMutation>;
export type MicrocreditReviewMutationResult = Apollo.MutationResult<MicrocreditReviewMutation>;
export type MicrocreditReviewMutationOptions = Apollo.BaseMutationOptions<
	MicrocreditReviewMutation,
	MicrocreditReviewMutationVariables
>;
export const PassRequestToCommitteeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'PassRequestToCommittee' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'PassRequestToCreditCommitteeInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'passRequestToCreditCommittee' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type PassRequestToCommitteeMutationFn = Apollo.MutationFunction<
	PassRequestToCommitteeMutation,
	PassRequestToCommitteeMutationVariables
>;

/**
 * __usePassRequestToCommitteeMutation__
 *
 * To run a mutation, you first call `usePassRequestToCommitteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassRequestToCommitteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passRequestToCommitteeMutation, { data, loading, error }] = usePassRequestToCommitteeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePassRequestToCommitteeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PassRequestToCommitteeMutation,
		PassRequestToCommitteeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PassRequestToCommitteeMutation,
		PassRequestToCommitteeMutationVariables
	>(PassRequestToCommitteeDocument, options);
}
export type PassRequestToCommitteeMutationHookResult = ReturnType<
	typeof usePassRequestToCommitteeMutation
>;
export type PassRequestToCommitteeMutationResult =
	Apollo.MutationResult<PassRequestToCommitteeMutation>;
export type PassRequestToCommitteeMutationOptions = Apollo.BaseMutationOptions<
	PassRequestToCommitteeMutation,
	PassRequestToCommitteeMutationVariables
>;
export const ApproveRequestByCreditCommitteeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ApproveRequestByCreditCommittee' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ApproveRequestByCreditCommitteeInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'approveRequestByCreditCommittee' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ApproveRequestByCreditCommitteeMutationFn = Apollo.MutationFunction<
	ApproveRequestByCreditCommitteeMutation,
	ApproveRequestByCreditCommitteeMutationVariables
>;

/**
 * __useApproveRequestByCreditCommitteeMutation__
 *
 * To run a mutation, you first call `useApproveRequestByCreditCommitteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRequestByCreditCommitteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRequestByCreditCommitteeMutation, { data, loading, error }] = useApproveRequestByCreditCommitteeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveRequestByCreditCommitteeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveRequestByCreditCommitteeMutation,
		ApproveRequestByCreditCommitteeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApproveRequestByCreditCommitteeMutation,
		ApproveRequestByCreditCommitteeMutationVariables
	>(ApproveRequestByCreditCommitteeDocument, options);
}
export type ApproveRequestByCreditCommitteeMutationHookResult = ReturnType<
	typeof useApproveRequestByCreditCommitteeMutation
>;
export type ApproveRequestByCreditCommitteeMutationResult =
	Apollo.MutationResult<ApproveRequestByCreditCommitteeMutation>;
export type ApproveRequestByCreditCommitteeMutationOptions = Apollo.BaseMutationOptions<
	ApproveRequestByCreditCommitteeMutation,
	ApproveRequestByCreditCommitteeMutationVariables
>;
export const RejectRequestByCreditCommitteeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RejectRequestByCreditCommittee' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'RejectRequestByCreditCommitteeInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rejectRequestByCreditCommittee' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RejectRequestByCreditCommitteeMutationFn = Apollo.MutationFunction<
	RejectRequestByCreditCommitteeMutation,
	RejectRequestByCreditCommitteeMutationVariables
>;

/**
 * __useRejectRequestByCreditCommitteeMutation__
 *
 * To run a mutation, you first call `useRejectRequestByCreditCommitteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRequestByCreditCommitteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRequestByCreditCommitteeMutation, { data, loading, error }] = useRejectRequestByCreditCommitteeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectRequestByCreditCommitteeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectRequestByCreditCommitteeMutation,
		RejectRequestByCreditCommitteeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectRequestByCreditCommitteeMutation,
		RejectRequestByCreditCommitteeMutationVariables
	>(RejectRequestByCreditCommitteeDocument, options);
}
export type RejectRequestByCreditCommitteeMutationHookResult = ReturnType<
	typeof useRejectRequestByCreditCommitteeMutation
>;
export type RejectRequestByCreditCommitteeMutationResult =
	Apollo.MutationResult<RejectRequestByCreditCommitteeMutation>;
export type RejectRequestByCreditCommitteeMutationOptions = Apollo.BaseMutationOptions<
	RejectRequestByCreditCommitteeMutation,
	RejectRequestByCreditCommitteeMutationVariables
>;
export const GetMicrocreditRequestDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'GetMicrocreditRequest' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'node' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'InlineFragment',
									typeCondition: {
										kind: 'NamedType',
										name: { kind: 'Name', value: 'MicrocreditRequest' }
									},
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'microcreditRequestId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'microcreditRequestStatus' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncome' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncomeIndex' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'recoveryTimeInYears' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyIi' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'personalInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'houseType' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'livesWithWhichFamilyMember' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'transportationMethod' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'childDependants' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'otherFamilyDependants' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'otherFamilyDependantsExplanation' }
														}
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'activityOrBusinessInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'activityDetail' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'operatingTimeRange' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'creditDetails' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'creditUse' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'creditUseDetail' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'amountRequested' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'expectedAdditionalIncome' }
														}
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'monthlyIncomeInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'businessSales' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'salary' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'familyContributionsIncome' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'otherSourcesIncome' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'otherSourcesIncomeDetail' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'totalIncome' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'monthlyBusinessExpenses' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'rent' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'electricBill' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'internetBill' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'equipmentMaintenance' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'inputsPurchase' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'salaries' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'gas' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'totalBusinessExpenses' }
														}
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'monthlyHouseExpenses' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'rent' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'electricBill' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'internetBill' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'waterBill' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'groceries' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'tuitions' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'familyExpenses' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'totalHouseExpenses' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'valueOfAssets' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'homeValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'landValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'carsValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'equipmentValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'equipmentDetail' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'savings' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'totalValueOfAssets' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'otherCredits' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'currentTotalDebt' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'monthlyPaymentToCredits' }
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'onboardingRegistryDeliberation' }
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'creditBureauReport' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstCreditDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'oldestDuePayment' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'totalCreditBalance' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'totalActiveCreditBalance' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'totalNumberOfCredits' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'totalActiveNumberOfCredits' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'creditBureauScore' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'callComments' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'evaluationMatrix' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'applicantPaymentExperienceI' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'applicantPaymentExperienceIi' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyIi' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'familyMemberPaymentExperienceIi' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'applicantNetIncomeIndex' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'totalScore' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'simulation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'numberOfPeriods' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'daysPerPeriod' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'paymentCapacity' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'lastPaymentAmount' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'configuration' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'amountRequested' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'paymentCapacity' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'daysPerPeriod' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'maximumNumberOfPeriods' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'ordinaryInterestRate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'firstPaymentDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'sameDayPayment' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'percentageOfCreditToSettle' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'highestAmountToApprove' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'minimumPaymentToSettleTheCreditTotal'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'minimumPaymentToSettleTheCreditPercentage'
																		}
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'installments' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'paymentNumber' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'initialBalance' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'creditPayment' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'principalPayment' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'interestPayment' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'interestTax' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'totalPayment' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'outstandingBalance' }
																	}
																]
															}
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'creditAreaOpinion' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'applicantComprehensiveOperativeEfficiency' }
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'businessComprehensiveOperativeEfficiency' }
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'committeeDeliberation' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'committeeRequestedChanges' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'committeeRuling' } }
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useGetMicrocreditRequestQuery__
 *
 * To run a query within a React component, call `useGetMicrocreditRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrocreditRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrocreditRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMicrocreditRequestQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetMicrocreditRequestQuery,
		GetMicrocreditRequestQueryVariables
	> &
		({ variables: GetMicrocreditRequestQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMicrocreditRequestQuery, GetMicrocreditRequestQueryVariables>(
		GetMicrocreditRequestDocument,
		options
	);
}
export function useGetMicrocreditRequestLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMicrocreditRequestQuery,
		GetMicrocreditRequestQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetMicrocreditRequestQuery, GetMicrocreditRequestQueryVariables>(
		GetMicrocreditRequestDocument,
		options
	);
}
export function useGetMicrocreditRequestSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetMicrocreditRequestQuery,
				GetMicrocreditRequestQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetMicrocreditRequestQuery, GetMicrocreditRequestQueryVariables>(
		GetMicrocreditRequestDocument,
		options
	);
}
export type GetMicrocreditRequestQueryHookResult = ReturnType<typeof useGetMicrocreditRequestQuery>;
export type GetMicrocreditRequestLazyQueryHookResult = ReturnType<
	typeof useGetMicrocreditRequestLazyQuery
>;
export type GetMicrocreditRequestSuspenseQueryHookResult = ReturnType<
	typeof useGetMicrocreditRequestSuspenseQuery
>;
export type GetMicrocreditRequestQueryResult = Apollo.QueryResult<
	GetMicrocreditRequestQuery,
	GetMicrocreditRequestQueryVariables
>;
export function refetchGetMicrocreditRequestQuery(variables: GetMicrocreditRequestQueryVariables) {
	return { query: GetMicrocreditRequestDocument, variables: variables };
}
export const GetMicrocreditRequestBasicDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'GetMicrocreditRequestBasic' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'node' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'InlineFragment',
									typeCondition: {
										kind: 'NamedType',
										name: { kind: 'Name', value: 'MicrocreditRequest' }
									},
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'microcreditRequestId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'microcreditRequestStatus' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncome' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'creditDetails' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'amountRequested' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'evaluationMatrix' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'totalScore' } }
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useGetMicrocreditRequestBasicQuery__
 *
 * To run a query within a React component, call `useGetMicrocreditRequestBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrocreditRequestBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrocreditRequestBasicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMicrocreditRequestBasicQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetMicrocreditRequestBasicQuery,
		GetMicrocreditRequestBasicQueryVariables
	> &
		({ variables: GetMicrocreditRequestBasicQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMicrocreditRequestBasicQuery, GetMicrocreditRequestBasicQueryVariables>(
		GetMicrocreditRequestBasicDocument,
		options
	);
}
export function useGetMicrocreditRequestBasicLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMicrocreditRequestBasicQuery,
		GetMicrocreditRequestBasicQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetMicrocreditRequestBasicQuery,
		GetMicrocreditRequestBasicQueryVariables
	>(GetMicrocreditRequestBasicDocument, options);
}
export function useGetMicrocreditRequestBasicSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetMicrocreditRequestBasicQuery,
				GetMicrocreditRequestBasicQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetMicrocreditRequestBasicQuery,
		GetMicrocreditRequestBasicQueryVariables
	>(GetMicrocreditRequestBasicDocument, options);
}
export type GetMicrocreditRequestBasicQueryHookResult = ReturnType<
	typeof useGetMicrocreditRequestBasicQuery
>;
export type GetMicrocreditRequestBasicLazyQueryHookResult = ReturnType<
	typeof useGetMicrocreditRequestBasicLazyQuery
>;
export type GetMicrocreditRequestBasicSuspenseQueryHookResult = ReturnType<
	typeof useGetMicrocreditRequestBasicSuspenseQuery
>;
export type GetMicrocreditRequestBasicQueryResult = Apollo.QueryResult<
	GetMicrocreditRequestBasicQuery,
	GetMicrocreditRequestBasicQueryVariables
>;
export function refetchGetMicrocreditRequestBasicQuery(
	variables: GetMicrocreditRequestBasicQueryVariables
) {
	return { query: GetMicrocreditRequestBasicDocument, variables: variables };
}
export const MicrocreditRequestsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'MicrocreditRequests' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } },
					type: {
						kind: 'ListType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'MicrocreditRequestSort' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'MicrocreditRequestFilter' } }
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'microcreditRequests' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'before' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'last' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sorts' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'microcreditRequestStatus' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'microcreditRequestId' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditDetails' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'amountRequested' }
																	}
																]
															}
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'count' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
										}
									]
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useMicrocreditRequestsQuery__
 *
 * To run a query within a React component, call `useMicrocreditRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrocreditRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrocreditRequestsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sorts: // value for 'sorts'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMicrocreditRequestsQuery(
	baseOptions?: Apollo.QueryHookOptions<MicrocreditRequestsQuery, MicrocreditRequestsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MicrocreditRequestsQuery, MicrocreditRequestsQueryVariables>(
		MicrocreditRequestsDocument,
		options
	);
}
export function useMicrocreditRequestsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MicrocreditRequestsQuery,
		MicrocreditRequestsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MicrocreditRequestsQuery, MicrocreditRequestsQueryVariables>(
		MicrocreditRequestsDocument,
		options
	);
}
export function useMicrocreditRequestsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<MicrocreditRequestsQuery, MicrocreditRequestsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MicrocreditRequestsQuery, MicrocreditRequestsQueryVariables>(
		MicrocreditRequestsDocument,
		options
	);
}
export type MicrocreditRequestsQueryHookResult = ReturnType<typeof useMicrocreditRequestsQuery>;
export type MicrocreditRequestsLazyQueryHookResult = ReturnType<
	typeof useMicrocreditRequestsLazyQuery
>;
export type MicrocreditRequestsSuspenseQueryHookResult = ReturnType<
	typeof useMicrocreditRequestsSuspenseQuery
>;
export type MicrocreditRequestsQueryResult = Apollo.QueryResult<
	MicrocreditRequestsQuery,
	MicrocreditRequestsQueryVariables
>;
export function refetchMicrocreditRequestsQuery(variables?: MicrocreditRequestsQueryVariables) {
	return { query: MicrocreditRequestsDocument, variables: variables };
}
export const MicrocreditRequestsByStatusDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'MicrocreditRequestsByStatus' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
					type: {
						kind: 'ListType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'MicrocreditRequestStatus' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'onboardingStatus' } },
					type: {
						kind: 'ListType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'OnboardingStatus' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
					defaultValue: { kind: 'IntValue', value: '10' }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'microcreditRequests' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'ObjectValue',
									fields: [
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'microcreditRequestStatus' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } }
										},
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'onboardingStatus' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'onboardingStatus' } }
										}
									]
								}
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sorts' },
								value: {
									kind: 'ListValue',
									values: [
										{
											kind: 'ObjectValue',
											fields: [
												{
													kind: 'ObjectField',
													name: { kind: 'Name', value: 'startedAt' },
													value: { kind: 'EnumValue', value: 'DESC' }
												}
											]
										}
									]
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'microcreditRequestId' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'microcreditRequestStatus' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncome' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditDetails' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'amountRequested' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'evaluationMatrix' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'totalScore' } }
																]
															}
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } }
										]
									}
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'count' } }
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useMicrocreditRequestsByStatusQuery__
 *
 * To run a query within a React component, call `useMicrocreditRequestsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrocreditRequestsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrocreditRequestsByStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *      onboardingStatus: // value for 'onboardingStatus'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMicrocreditRequestsByStatusQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MicrocreditRequestsByStatusQuery,
		MicrocreditRequestsByStatusQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MicrocreditRequestsByStatusQuery,
		MicrocreditRequestsByStatusQueryVariables
	>(MicrocreditRequestsByStatusDocument, options);
}
export function useMicrocreditRequestsByStatusLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MicrocreditRequestsByStatusQuery,
		MicrocreditRequestsByStatusQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MicrocreditRequestsByStatusQuery,
		MicrocreditRequestsByStatusQueryVariables
	>(MicrocreditRequestsByStatusDocument, options);
}
export function useMicrocreditRequestsByStatusSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				MicrocreditRequestsByStatusQuery,
				MicrocreditRequestsByStatusQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MicrocreditRequestsByStatusQuery,
		MicrocreditRequestsByStatusQueryVariables
	>(MicrocreditRequestsByStatusDocument, options);
}
export type MicrocreditRequestsByStatusQueryHookResult = ReturnType<
	typeof useMicrocreditRequestsByStatusQuery
>;
export type MicrocreditRequestsByStatusLazyQueryHookResult = ReturnType<
	typeof useMicrocreditRequestsByStatusLazyQuery
>;
export type MicrocreditRequestsByStatusSuspenseQueryHookResult = ReturnType<
	typeof useMicrocreditRequestsByStatusSuspenseQuery
>;
export type MicrocreditRequestsByStatusQueryResult = Apollo.QueryResult<
	MicrocreditRequestsByStatusQuery,
	MicrocreditRequestsByStatusQueryVariables
>;
export function refetchMicrocreditRequestsByStatusQuery(
	variables?: MicrocreditRequestsByStatusQueryVariables
) {
	return { query: MicrocreditRequestsByStatusDocument, variables: variables };
}
export const SearchMicrocreditRequestsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'SearchMicrocreditRequests' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
					defaultValue: { kind: 'IntValue', value: '10' }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'microcreditRequests' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'ObjectValue',
									fields: [
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'searchTerm' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } }
										}
									]
								}
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sorts' },
								value: {
									kind: 'ListValue',
									values: [
										{
											kind: 'ObjectValue',
											fields: [
												{
													kind: 'ObjectField',
													name: { kind: 'Name', value: 'startedAt' },
													value: { kind: 'EnumValue', value: 'DESC' }
												}
											]
										}
									]
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'microcreditRequestId' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'microcreditRequestStatus' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditDetails' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'amountRequested' }
																	}
																]
															}
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } }
										]
									}
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'count' } }
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useSearchMicrocreditRequestsQuery__
 *
 * To run a query within a React component, call `useSearchMicrocreditRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMicrocreditRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMicrocreditRequestsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchMicrocreditRequestsQuery(
	baseOptions: Apollo.QueryHookOptions<
		SearchMicrocreditRequestsQuery,
		SearchMicrocreditRequestsQueryVariables
	> &
		({ variables: SearchMicrocreditRequestsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SearchMicrocreditRequestsQuery, SearchMicrocreditRequestsQueryVariables>(
		SearchMicrocreditRequestsDocument,
		options
	);
}
export function useSearchMicrocreditRequestsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SearchMicrocreditRequestsQuery,
		SearchMicrocreditRequestsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SearchMicrocreditRequestsQuery,
		SearchMicrocreditRequestsQueryVariables
	>(SearchMicrocreditRequestsDocument, options);
}
export function useSearchMicrocreditRequestsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				SearchMicrocreditRequestsQuery,
				SearchMicrocreditRequestsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		SearchMicrocreditRequestsQuery,
		SearchMicrocreditRequestsQueryVariables
	>(SearchMicrocreditRequestsDocument, options);
}
export type SearchMicrocreditRequestsQueryHookResult = ReturnType<
	typeof useSearchMicrocreditRequestsQuery
>;
export type SearchMicrocreditRequestsLazyQueryHookResult = ReturnType<
	typeof useSearchMicrocreditRequestsLazyQuery
>;
export type SearchMicrocreditRequestsSuspenseQueryHookResult = ReturnType<
	typeof useSearchMicrocreditRequestsSuspenseQuery
>;
export type SearchMicrocreditRequestsQueryResult = Apollo.QueryResult<
	SearchMicrocreditRequestsQuery,
	SearchMicrocreditRequestsQueryVariables
>;
export function refetchSearchMicrocreditRequestsQuery(
	variables: SearchMicrocreditRequestsQueryVariables
) {
	return { query: SearchMicrocreditRequestsDocument, variables: variables };
}
export const MicrocreditRequestsByDateRangeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'MicrocreditRequestsByDateRange' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
					defaultValue: { kind: 'IntValue', value: '10' }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'microcreditRequests' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'ObjectValue',
									fields: [
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'startedAt' },
											value: {
												kind: 'ObjectValue',
												fields: [
													{
														kind: 'ObjectField',
														name: { kind: 'Name', value: 'from' },
														value: { kind: 'Variable', name: { kind: 'Name', value: 'from' } }
													},
													{
														kind: 'ObjectField',
														name: { kind: 'Name', value: 'to' },
														value: { kind: 'Variable', name: { kind: 'Name', value: 'to' } }
													}
												]
											}
										}
									]
								}
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sorts' },
								value: {
									kind: 'ListValue',
									values: [
										{
											kind: 'ObjectValue',
											fields: [
												{
													kind: 'ObjectField',
													name: { kind: 'Name', value: 'startedAt' },
													value: { kind: 'EnumValue', value: 'DESC' }
												}
											]
										}
									]
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'microcreditRequestId' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'microcreditRequestStatus' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncome' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'recoveryTimeInYears' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyIi' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditDetails' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'amountRequested' }
																	}
																]
															}
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } }
										]
									}
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'count' } }
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useMicrocreditRequestsByDateRangeQuery__
 *
 * To run a query within a React component, call `useMicrocreditRequestsByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrocreditRequestsByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrocreditRequestsByDateRangeQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMicrocreditRequestsByDateRangeQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MicrocreditRequestsByDateRangeQuery,
		MicrocreditRequestsByDateRangeQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MicrocreditRequestsByDateRangeQuery,
		MicrocreditRequestsByDateRangeQueryVariables
	>(MicrocreditRequestsByDateRangeDocument, options);
}
export function useMicrocreditRequestsByDateRangeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MicrocreditRequestsByDateRangeQuery,
		MicrocreditRequestsByDateRangeQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MicrocreditRequestsByDateRangeQuery,
		MicrocreditRequestsByDateRangeQueryVariables
	>(MicrocreditRequestsByDateRangeDocument, options);
}
export function useMicrocreditRequestsByDateRangeSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				MicrocreditRequestsByDateRangeQuery,
				MicrocreditRequestsByDateRangeQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MicrocreditRequestsByDateRangeQuery,
		MicrocreditRequestsByDateRangeQueryVariables
	>(MicrocreditRequestsByDateRangeDocument, options);
}
export type MicrocreditRequestsByDateRangeQueryHookResult = ReturnType<
	typeof useMicrocreditRequestsByDateRangeQuery
>;
export type MicrocreditRequestsByDateRangeLazyQueryHookResult = ReturnType<
	typeof useMicrocreditRequestsByDateRangeLazyQuery
>;
export type MicrocreditRequestsByDateRangeSuspenseQueryHookResult = ReturnType<
	typeof useMicrocreditRequestsByDateRangeSuspenseQuery
>;
export type MicrocreditRequestsByDateRangeQueryResult = Apollo.QueryResult<
	MicrocreditRequestsByDateRangeQuery,
	MicrocreditRequestsByDateRangeQueryVariables
>;
export function refetchMicrocreditRequestsByDateRangeQuery(
	variables?: MicrocreditRequestsByDateRangeQueryVariables
) {
	return { query: MicrocreditRequestsByDateRangeDocument, variables: variables };
}
export const GetEvaluationMatrixDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'GetEvaluationMatrix' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'node' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'InlineFragment',
									typeCondition: {
										kind: 'NamedType',
										name: { kind: 'Name', value: 'MicrocreditRequest' }
									},
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'microcreditRequestId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncome' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncomeIndex' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'recoveryTimeInYears' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyIi' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'evaluationMatrix' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'applicantPaymentExperienceI' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'applicantPaymentExperienceIi' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'familyMemberPaymentExperienceIi' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyIi' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'applicantNetIncomeIndex' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'totalScore' } }
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useGetEvaluationMatrixQuery__
 *
 * To run a query within a React component, call `useGetEvaluationMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEvaluationMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEvaluationMatrixQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEvaluationMatrixQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetEvaluationMatrixQuery,
		GetEvaluationMatrixQueryVariables
	> &
		({ variables: GetEvaluationMatrixQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetEvaluationMatrixQuery, GetEvaluationMatrixQueryVariables>(
		GetEvaluationMatrixDocument,
		options
	);
}
export function useGetEvaluationMatrixLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetEvaluationMatrixQuery,
		GetEvaluationMatrixQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetEvaluationMatrixQuery, GetEvaluationMatrixQueryVariables>(
		GetEvaluationMatrixDocument,
		options
	);
}
export function useGetEvaluationMatrixSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetEvaluationMatrixQuery, GetEvaluationMatrixQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetEvaluationMatrixQuery, GetEvaluationMatrixQueryVariables>(
		GetEvaluationMatrixDocument,
		options
	);
}
export type GetEvaluationMatrixQueryHookResult = ReturnType<typeof useGetEvaluationMatrixQuery>;
export type GetEvaluationMatrixLazyQueryHookResult = ReturnType<
	typeof useGetEvaluationMatrixLazyQuery
>;
export type GetEvaluationMatrixSuspenseQueryHookResult = ReturnType<
	typeof useGetEvaluationMatrixSuspenseQuery
>;
export type GetEvaluationMatrixQueryResult = Apollo.QueryResult<
	GetEvaluationMatrixQuery,
	GetEvaluationMatrixQueryVariables
>;
export function refetchGetEvaluationMatrixQuery(variables: GetEvaluationMatrixQueryVariables) {
	return { query: GetEvaluationMatrixDocument, variables: variables };
}
export const GetSimulationDetailsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'GetSimulationDetails' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'node' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'InlineFragment',
									typeCondition: {
										kind: 'NamedType',
										name: { kind: 'Name', value: 'MicrocreditRequest' }
									},
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'microcreditRequestId' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'simulation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'numberOfPeriods' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'daysPerPeriod' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'paymentCapacity' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'lastPaymentAmount' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'configuration' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'amountRequested' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'paymentCapacity' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'daysPerPeriod' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'maximumNumberOfPeriods' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'ordinaryInterestRate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'firstPaymentDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'sameDayPayment' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'percentageOfCreditToSettle' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'highestAmountToApprove' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'minimumPaymentToSettleTheCreditTotal'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'minimumPaymentToSettleTheCreditPercentage'
																		}
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'installments' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'paymentNumber' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'initialBalance' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'creditPayment' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'principalPayment' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'interestPayment' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'interestTax' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'totalPayment' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'outstandingBalance' }
																	}
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useGetSimulationDetailsQuery__
 *
 * To run a query within a React component, call `useGetSimulationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimulationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimulationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSimulationDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetSimulationDetailsQuery,
		GetSimulationDetailsQueryVariables
	> &
		({ variables: GetSimulationDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetSimulationDetailsQuery, GetSimulationDetailsQueryVariables>(
		GetSimulationDetailsDocument,
		options
	);
}
export function useGetSimulationDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSimulationDetailsQuery,
		GetSimulationDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetSimulationDetailsQuery, GetSimulationDetailsQueryVariables>(
		GetSimulationDetailsDocument,
		options
	);
}
export function useGetSimulationDetailsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetSimulationDetailsQuery, GetSimulationDetailsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetSimulationDetailsQuery, GetSimulationDetailsQueryVariables>(
		GetSimulationDetailsDocument,
		options
	);
}
export type GetSimulationDetailsQueryHookResult = ReturnType<typeof useGetSimulationDetailsQuery>;
export type GetSimulationDetailsLazyQueryHookResult = ReturnType<
	typeof useGetSimulationDetailsLazyQuery
>;
export type GetSimulationDetailsSuspenseQueryHookResult = ReturnType<
	typeof useGetSimulationDetailsSuspenseQuery
>;
export type GetSimulationDetailsQueryResult = Apollo.QueryResult<
	GetSimulationDetailsQuery,
	GetSimulationDetailsQueryVariables
>;
export function refetchGetSimulationDetailsQuery(variables: GetSimulationDetailsQueryVariables) {
	return { query: GetSimulationDetailsDocument, variables: variables };
}
